export const headCopy = {
  head_playground_title:
    "Playground - Um editor online para explorar TypeScript e JavaScript",
  head_playground_description:
    "O Playground permite que você escreva TypeScript ou JavaScript online de maneira segura e compartilhável.",
  tsconfig_title:
    "Referência de TSConfig - Documentos em todas as opções do TSConfig",
  tsconfig_description:
    "De 'allowJs' até 'useDefineForClassFields', a referência de TSConfig inclui informações sobre todas as 'flags' de compilador ativas configurando um projeto TypeScript",
  playground_example_prefix: "Exemplo de Playground - ",

  head_index_title: "JavaScript Tipado em Qualquer Escala",
  head_index_description: "JavaScript Tipado em Qualquer Escala",
}
